export type VipClubStatus = 'active' | 'inactive' | 'coming_soon';

export interface VipClubBenefits {
  exclusiveContent: boolean;
  exclusiveContentCount: number;
  exclusiveEvents: boolean;
  exclusiveEventsCount: number;
  giveaways: boolean;
  giveawaysCount: number;
  prizes: boolean;
  prizesCount: number;
}

export interface VipClubRecentEvent {
  name: string;
  date: string;
}

export interface VipClubRecentPrize {
  name: string;
  winner: string;
  date: string;
}

export interface VipClub {
  id: number;
  radioName: string;
  radioFrequency: string;
  radioCategory: string;
  clubName: string;
  description: string;
  membersCount: number;
  memberLimit: number;
  monthlyPrice: number;
  currency: string;
  status: VipClubStatus;
  benefits: VipClubBenefits;
  recentEvents: VipClubRecentEvent[];
  recentPrizes: VipClubRecentPrize[];
  engagementRate: number;
  createdAt: string;
  thumbnailUrl: string;
}

export interface VipClubsSummary {
  totalClubs: number;
  activeClubs: number;
  totalMembers: number;
  potentialMonthlyRevenue: number;
  totalExclusiveContent: number;
  totalExclusiveEvents: number;
  totalGiveaways: number;
  totalPrizes: number;
}

export const vipClubsSummary: VipClubsSummary = {
  totalClubs: 15,
  activeClubs: 11,
  totalMembers: 8470,
  potentialMonthlyRevenue: 42650,
  totalExclusiveContent: 246,
  totalExclusiveEvents: 38,
  totalGiveaways: 52,
  totalPrizes: 89,
};

export const vipClubs: VipClub[] = [
  {
    id: 1,
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.7 FM',
    radioCategory: 'Éxitos',
    clubName: 'Éxito VIP',
    description: 'Acceso exclusivo a contenido premium, meet & greets con locutores y participación prioritaria en todos los sorteos de la radio.',
    membersCount: 1250,
    memberLimit: 2000,
    monthlyPrice: 5.99,
    currency: 'USD',
    status: 'active',
    benefits: {
      exclusiveContent: true,
      exclusiveContentCount: 45,
      exclusiveEvents: true,
      exclusiveEventsCount: 6,
      giveaways: true,
      giveawaysCount: 8,
      prizes: true,
      prizesCount: 15,
    },
    recentEvents: [
      { name: 'Concierto Privado Carlos Vives', date: '2026-05-20' },
      { name: 'Masterclass con Isabella Torres', date: '2026-06-10' },
    ],
    recentPrizes: [
      { name: 'iPhone 16 Pro', winner: 'María García', date: '2026-06-05' },
      { name: 'Viaje a Cancún', winner: 'Pedro López', date: '2026-05-15' },
      { name: 'Bono $500 USD', winner: 'Ana Martínez', date: '2026-04-28' },
    ],
    engagementRate: 78,
    createdAt: '2025-09-15',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Premium%20gold%20VIP%20club%20membership%20card%20with%20elegant%20diamond%20crown%20logo%20on%20dark%20background%2C%20luxury%20membership%20card%20design%20with%20holographic%20foil%20effect%2C%20exclusive%20members%20only%20aesthetic%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-01&orientation=squarish',
  },
  {
    id: 2,
    radioName: 'Radio Deportiva Total',
    radioFrequency: '1010 AM',
    radioCategory: 'Deportes',
    clubName: 'Deportivo VIP',
    description: 'Predicciones exclusivas, análisis táctico avanzado, acceso a cabina en vivo y entradas VIP a eventos deportivos.',
    membersCount: 980,
    memberLimit: 1500,
    monthlyPrice: 7.99,
    currency: 'USD',
    status: 'active',
    benefits: {
      exclusiveContent: true,
      exclusiveContentCount: 38,
      exclusiveEvents: true,
      exclusiveEventsCount: 5,
      giveaways: true,
      giveawaysCount: 6,
      prizes: true,
      prizesCount: 12,
    },
    recentEvents: [
      { name: 'Palco VIP Final Champions', date: '2026-06-01' },
      { name: 'Meet & Greet Selección Nacional', date: '2026-05-25' },
    ],
    recentPrizes: [
      { name: 'Camiseta Oficial Firmada', winner: 'Carlos Ruiz', date: '2026-06-02' },
      { name: 'Entradas VIP Dobles', winner: 'Diego Fernández', date: '2026-05-18' },
    ],
    engagementRate: 82,
    createdAt: '2025-11-01',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Premium%20sports%20VIP%20membership%20card%20with%20gold%20trophy%20emblem%20and%20stadium%20background%2C%20black%20and%20gold%20luxury%20design%2C%20exclusive%20sports%20club%20aesthetic%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-02&orientation=squarish',
  },
  {
    id: 3,
    radioName: 'Estéreo Capital',
    radioFrequency: '92.1 FM',
    radioCategory: 'Música y Cultura',
    clubName: 'Capital Select',
    description: 'Contenido cultural curado, acceso a galerías y museos, preventa de conciertos y experiencias gastronómicas exclusivas.',
    membersCount: 760,
    memberLimit: 1200,
    monthlyPrice: 9.99,
    currency: 'USD',
    status: 'active',
    benefits: {
      exclusiveContent: true,
      exclusiveContentCount: 32,
      exclusiveEvents: true,
      exclusiveEventsCount: 4,
      giveaways: true,
      giveawaysCount: 5,
      prizes: true,
      prizesCount: 10,
    },
    recentEvents: [
      { name: 'Cena Privada Chef Estrella', date: '2026-06-15' },
      { name: 'Visita Privada Museo Nacional', date: '2026-05-30' },
    ],
    recentPrizes: [
      { name: 'Suscripción Anual Teatro', winner: 'Laura Sánchez', date: '2026-05-20' },
      { name: 'Colección Vinilos Premium', winner: 'Andrés Mora', date: '2026-04-15' },
    ],
    engagementRate: 71,
    createdAt: '2025-10-20',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Elegant%20black%20VIP%20membership%20card%20with%20silver%20art%20deco%20pattern%20and%20cultural%20emblem%2C%20sophisticated%20luxury%20design%2C%20premium%20cultural%20club%20aesthetic%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-03&orientation=squarish',
  },
  {
    id: 4,
    radioName: 'Radio Juvenil FM',
    radioFrequency: '105.3 FM',
    radioCategory: 'Música Juvenil',
    clubName: 'Juvenil Elite',
    description: 'Playlists secretas, filtros exclusivos en redes, acceso a festivales y meetups con artistas revelación cada mes.',
    membersCount: 1420,
    memberLimit: 2000,
    monthlyPrice: 3.99,
    currency: 'USD',
    status: 'active',
    benefits: {
      exclusiveContent: true,
      exclusiveContentCount: 28,
      exclusiveEvents: true,
      exclusiveEventsCount: 4,
      giveaways: true,
      giveawaysCount: 7,
      prizes: true,
      prizesCount: 9,
    },
    recentEvents: [
      { name: 'Backstage Festival Sonoro', date: '2026-06-22' },
      { name: 'Sesión Acústica Exclusiva', date: '2026-05-12' },
    ],
    recentPrizes: [
      { name: 'Pase VIP Festival 2026', winner: 'Sofía Ramírez', date: '2026-06-01' },
      { name: 'Audífonos Premium', winner: 'Mateo Vega', date: '2026-05-08' },
      { name: 'Merch Oficial Edición Limitada', winner: 'Valentina Ríos', date: '2026-04-20' },
    ],
    engagementRate: 85,
    createdAt: '2025-08-10',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20neon%20purple%20VIP%20membership%20card%20with%20holographic%20foil%20and%20graffiti%20style%20crown%2C%20modern%20youth%20culture%20aesthetic%2C%20exclusive%20club%20vibe%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-04&orientation=squarish',
  },
  {
    id: 5,
    radioName: 'Radio Noticias 24',
    radioFrequency: '89.5 FM',
    radioCategory: 'Noticias',
    clubName: 'Noticias Insider',
    description: 'Alertas tempranas, boletines reservados, acceso a la sala de redacción y briefings exclusivos con periodistas.',
    membersCount: 540,
    memberLimit: 800,
    monthlyPrice: 12.99,
    currency: 'USD',
    status: 'active',
    benefits: {
      exclusiveContent: true,
      exclusiveContentCount: 56,
      exclusiveEvents: true,
      exclusiveEventsCount: 3,
      giveaways: false,
      giveawaysCount: 0,
      prizes: false,
      prizesCount: 0,
    },
    recentEvents: [
      { name: 'Briefing Elecciones 2026', date: '2026-05-28' },
      { name: 'Visita Sala de Redacción', date: '2026-04-15' },
    ],
    recentPrizes: [],
    engagementRate: 68,
    createdAt: '2025-12-05',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Professional%20navy%20blue%20VIP%20membership%20card%20with%20silver%20globe%20emblem%20and%20newsroom%20aesthetic%2C%20premium%20journalism%20club%20design%2C%20exclusive%20insider%20membership%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-05&orientation=squarish',
  },
  {
    id: 6,
    radioName: 'Radio Rock 360',
    radioFrequency: '96.8 FM',
    radioCategory: 'Rock Nacional',
    clubName: 'Rock Legacy',
    description: 'Vinilos de colección, sesiones acústicas privadas, meet & greets con bandas legendarias y contenido detrás de cámaras.',
    membersCount: 680,
    memberLimit: 1000,
    monthlyPrice: 6.99,
    currency: 'USD',
    status: 'active',
    benefits: {
      exclusiveContent: true,
      exclusiveContentCount: 22,
      exclusiveEvents: true,
      exclusiveEventsCount: 3,
      giveaways: true,
      giveawaysCount: 4,
      prizes: true,
      prizesCount: 8,
    },
    recentEvents: [
      { name: 'Sesión Privada con Aterciopelados', date: '2026-06-08' },
      { name: 'Noche de Vinilos Exclusiva', date: '2026-05-20' },
    ],
    recentPrizes: [
      { name: 'Guitarra Firmada', winner: 'Daniel Ortega', date: '2026-05-30' },
      { name: 'Colección Vinilos 90s', winner: 'Catalina Muñoz', date: '2026-04-22' },
    ],
    engagementRate: 74,
    createdAt: '2025-10-01',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Dark%20rock%20themed%20VIP%20membership%20card%20with%20silver%20guitar%20pick%20emblem%20and%20distressed%20metal%20texture%2C%20edgy%20premium%20design%2C%20rock%20legacy%20club%20aesthetic%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-06&orientation=squarish',
  },
  {
    id: 7,
    radioName: 'Radio Clásica',
    radioFrequency: '101.5 FM',
    radioCategory: 'Música Clásica',
    clubName: 'Clásica Premier',
    description: 'Grabaciones inéditas, charlas con maestros, acceso preferencial a conciertos de temporada y contenido educativo exclusivo.',
    membersCount: 420,
    memberLimit: 600,
    monthlyPrice: 8.99,
    currency: 'USD',
    status: 'active',
    benefits: {
      exclusiveContent: true,
      exclusiveContentCount: 35,
      exclusiveEvents: true,
      exclusiveEventsCount: 3,
      giveaways: false,
      giveawaysCount: 0,
      prizes: true,
      prizesCount: 6,
    },
    recentEvents: [
      { name: 'Conferencia Maestro Dudamel', date: '2026-06-18' },
      { name: 'Ensayo Abierto Orquesta', date: '2026-05-10' },
    ],
    recentPrizes: [
      { name: 'Abono Temporada Sinfónica', winner: 'Beatriz Herrera', date: '2026-05-25' },
      { name: 'Palco Privado Ópera', winner: 'Roberto Álvarez', date: '2026-04-30' },
    ],
    engagementRate: 65,
    createdAt: '2025-11-20',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Refined%20ivory%20and%20gold%20VIP%20membership%20card%20with%20violin%20emblem%20and%20classical%20sheet%20music%20pattern%2C%20elegant%20premium%20design%2C%20classical%20music%20club%20aesthetic%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-07&orientation=squarish',
  },
  {
    id: 8,
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.7 FM',
    radioCategory: 'Éxitos',
    clubName: 'Éxito VIP Lite',
    description: 'Edición gratuita con acceso a contenido básico exclusivo, participación en sorteos semanales y newsletter premium.',
    membersCount: 2100,
    memberLimit: 5000,
    monthlyPrice: 0,
    currency: 'USD',
    status: 'active',
    benefits: {
      exclusiveContent: true,
      exclusiveContentCount: 12,
      exclusiveEvents: false,
      exclusiveEventsCount: 0,
      giveaways: true,
      giveawaysCount: 4,
      prizes: false,
      prizesCount: 0,
    },
    recentEvents: [],
    recentPrizes: [],
    engagementRate: 52,
    createdAt: '2026-03-01',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Simple%20silver%20VIP%20membership%20card%20with%20minimalist%20crown%20outline%20and%20gradient%20background%2C%20clean%20modern%20design%2C%20accessible%20premium%20club%20aesthetic%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-08&orientation=squarish',
  },
  {
    id: 9,
    radioName: 'Radio Deportiva Total',
    radioFrequency: '1010 AM',
    radioCategory: 'Deportes',
    clubName: 'Deportivo Pro',
    description: 'Plan profesional con estadísticas avanzadas, acceso a scouts, mentorías con ex-deportistas y networking VIP.',
    membersCount: 320,
    memberLimit: 500,
    monthlyPrice: 14.99,
    currency: 'USD',
    status: 'active',
    benefits: {
      exclusiveContent: true,
      exclusiveContentCount: 28,
      exclusiveEvents: true,
      exclusiveEventsCount: 2,
      giveaways: true,
      giveawaysCount: 3,
      prizes: true,
      prizesCount: 5,
    },
    recentEvents: [
      { name: 'Mentoría Virtual Ex-Futbolista', date: '2026-06-12' },
      { name: 'Networking Agencias Deportivas', date: '2026-05-05' },
    ],
    recentPrizes: [
      { name: 'Suscripción Plataforma Stats', winner: 'Julián Paredes', date: '2026-05-15' },
    ],
    engagementRate: 88,
    createdAt: '2026-02-15',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Premium%20black%20and%20gold%20VIP%20membership%20card%20with%20championship%20belt%20emblem%20and%20professional%20sports%20aesthetic%2C%20elite%20tier%20design%2C%20professional%20sports%20club%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-09&orientation=squarish',
  },
  {
    id: 10,
    radioName: 'Radio Juvenil FM',
    radioFrequency: '105.3 FM',
    radioCategory: 'Música Juvenil',
    clubName: 'Juvenil Creator',
    description: 'Para creadores de contenido: acceso a librería de samples, colaboraciones con artistas y mentorías de producción.',
    membersCount: 280,
    memberLimit: 400,
    monthlyPrice: 11.99,
    currency: 'USD',
    status: 'active',
    benefits: {
      exclusiveContent: true,
      exclusiveContentCount: 18,
      exclusiveEvents: true,
      exclusiveEventsCount: 2,
      giveaways: true,
      giveawaysCount: 2,
      prizes: true,
      prizesCount: 4,
    },
    recentEvents: [
      { name: 'Taller Producción Musical', date: '2026-06-05' },
      { name: 'Colaboración con DJ Revelación', date: '2026-05-18' },
    ],
    recentPrizes: [
      { name: 'Licencia Software Producción', winner: 'Kevin Toro', date: '2026-05-10' },
    ],
    engagementRate: 79,
    createdAt: '2026-01-10',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Creative%20neon%20green%20VIP%20membership%20card%20with%20music%20production%20waveform%20emblem%20and%20digital%20glitch%20effect%2C%20creator%20club%20design%2C%20modern%20music%20production%20aesthetic%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-10&orientation=squarish',
  },
  {
    id: 11,
    radioName: 'Estéreo Capital',
    radioFrequency: '92.1 FM',
    radioCategory: 'Música y Cultura',
    clubName: 'Capital Select Premium',
    description: 'Experiencias de lujo: viajes culturales, cenas con artistas, acceso a premieres y colecciones de arte privadas.',
    membersCount: 180,
    memberLimit: 250,
    monthlyPrice: 19.99,
    currency: 'USD',
    status: 'active',
    benefits: {
      exclusiveContent: true,
      exclusiveContentCount: 20,
      exclusiveEvents: true,
      exclusiveEventsCount: 2,
      giveaways: true,
      giveawaysCount: 2,
      prizes: true,
      prizesCount: 4,
    },
    recentEvents: [
      { name: 'Viaje Cultural Cartagena', date: '2026-07-10' },
      { name: 'Cena con Artista Plástico', date: '2026-06-20' },
    ],
    recentPrizes: [
      { name: 'Obra de Arte Original', winner: 'Mariana Duque', date: '2026-05-28' },
    ],
    engagementRate: 91,
    createdAt: '2026-02-01',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Ultra%20premium%20rose%20gold%20VIP%20membership%20card%20with%20diamond%20art%20emblem%20and%20luxury%20texture%2C%20exclusive%20high%20tier%20design%2C%20luxury%20cultural%20club%20aesthetic%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-11&orientation=squarish',
  },
  {
    id: 12,
    radioName: 'Radio Rock 360',
    radioFrequency: '96.8 FM',
    radioCategory: 'Rock Nacional',
    clubName: 'Rock Legacy Free',
    description: 'Acceso gratuito a newsletter de rock, notificaciones de conciertos y participación en trivia semanal con premios.',
    membersCount: 950,
    memberLimit: 2000,
    monthlyPrice: 0,
    currency: 'USD',
    status: 'coming_soon',
    benefits: {
      exclusiveContent: false,
      exclusiveContentCount: 0,
      exclusiveEvents: false,
      exclusiveEventsCount: 0,
      giveaways: true,
      giveawaysCount: 1,
      prizes: true,
      prizesCount: 2,
    },
    recentEvents: [],
    recentPrizes: [],
    engagementRate: 0,
    createdAt: '2026-08-01',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Minimal%20dark%20gray%20VIP%20membership%20card%20coming%20soon%20with%20guitar%20silhouette%2C%20anticipation%20design%2C%20rock%20radio%20free%20club%20preview%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-12&orientation=squarish',
  },
  {
    id: 13,
    radioName: 'Radio Noticias 24',
    radioFrequency: '89.5 FM',
    radioCategory: 'Noticias',
    clubName: 'Noticias Insider Pro',
    description: 'Análisis geopolítico profundo, reportes de inteligencia de mercados y acceso directo a corresponsales internacionales.',
    membersCount: 150,
    memberLimit: 200,
    monthlyPrice: 24.99,
    currency: 'USD',
    status: 'coming_soon',
    benefits: {
      exclusiveContent: true,
      exclusiveContentCount: 40,
      exclusiveEvents: true,
      exclusiveEventsCount: 2,
      giveaways: false,
      giveawaysCount: 0,
      prizes: false,
      prizesCount: 0,
    },
    recentEvents: [],
    recentPrizes: [],
    engagementRate: 0,
    createdAt: '2026-09-01',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Executive%20platinum%20VIP%20membership%20card%20with%20world%20map%20emblem%20and%20security%20hologram%2C%20intelligence%20tier%20design%2C%20premium%20news%20insider%20club%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-13&orientation=squarish',
  },
  {
    id: 14,
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.7 FM',
    radioCategory: 'Éxitos',
    clubName: 'Éxito VIP Familiar',
    description: 'Plan familiar con 4 membresías, contenido para niños, eventos familiares exclusivos y descuentos en parques.',
    membersCount: 0,
    memberLimit: 500,
    monthlyPrice: 8.99,
    currency: 'USD',
    status: 'coming_soon',
    benefits: {
      exclusiveContent: true,
      exclusiveContentCount: 15,
      exclusiveEvents: true,
      exclusiveEventsCount: 2,
      giveaways: true,
      giveawaysCount: 3,
      prizes: true,
      prizesCount: 4,
    },
    recentEvents: [],
    recentPrizes: [],
    engagementRate: 0,
    createdAt: '2026-07-15',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Warm%20orange%20VIP%20family%20membership%20card%20with%20heart%20emblem%20and%20playful%20design%20elements%2C%20family%20friendly%20premium%20club%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-14&orientation=squarish',
  },
  {
    id: 15,
    radioName: 'Radio Clásica',
    radioFrequency: '101.5 FM',
    radioCategory: 'Música Clásica',
    clubName: 'Clásica Estudiante',
    description: 'Plan con descuento para estudiantes: masterclasses, partituras digitales, y acceso a ensayos de orquesta.',
    membersCount: 0,
    memberLimit: 300,
    monthlyPrice: 3.99,
    currency: 'USD',
    status: 'inactive',
    benefits: {
      exclusiveContent: true,
      exclusiveContentCount: 10,
      exclusiveEvents: true,
      exclusiveEventsCount: 2,
      giveaways: false,
      giveawaysCount: 0,
      prizes: true,
      prizesCount: 2,
    },
    recentEvents: [],
    recentPrizes: [],
    engagementRate: 0,
    createdAt: '2026-04-01',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Affordable%20student%20VIP%20membership%20card%20with%20book%20and%20music%20note%20emblem%20on%20soft%20green%20background%2C%20educational%20discount%20design%2C%20student%20classical%20music%20club%2C%20editorial%20product%20photography&width=200&height=200&seq=vip-club-15&orientation=squarish',
  },
];

export const statusLabels: Record<VipClubStatus, string> = {
  active: 'Activo',
  inactive: 'Inactivo',
  coming_soon: 'Próximamente',
};

export const statusColors: Record<VipClubStatus, { badge: string; dot: string; text: string }> = {
  active: { badge: 'bg-emerald-50 border-emerald-200', dot: 'bg-emerald-400', text: 'text-emerald-700' },
  inactive: { badge: 'bg-stone-50 border-stone-200', dot: 'bg-stone-400', text: 'text-stone-500' },
  coming_soon: { badge: 'bg-amber-50 border-amber-200', dot: 'bg-amber-400', text: 'text-amber-700' },
};